<template>
    <div class="animated fadeIn">
      <membership-button-pay
        v-bind:membership="membership"
        @click="onClick"
        @paid="onPaid"
      >
      </membership-button-pay>
      <membership-button-cancel
        :membership="membership"
        @click="onClick"
        @cancelled="onCancelled"
      >
      </membership-button-cancel>
    </div>
</template>
<script>
    import {Membership} from "../../models/Membership"
    import MembershipButtonPay from "./buttons/MembershipPayButton";
    import MembershipButtonCancel from "./buttons/MembershipCancelButton";

    export default {
        name: 'membership-action-buttons',
        components: {
            MembershipButtonCancel,
            MembershipButtonPay,
        },
        props: {
            membership: {
                type: Object,
                default: new Membership(),
            },
        },
        methods: {
            onClick(){
                this.$emit('loading')
            },
            onPaid(member) {
                this.$emit('paid', member)
            },
            onCancelled(member) {
                this.$emit('cancelled', member)
            },
        }
    }
</script>
